"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDistributionDelay = exports.AnimationDuration = void 0;
const Game_1 = require("../game/Game");
var AnimationDuration;
(function (AnimationDuration) {
    AnimationDuration[AnimationDuration["DrawCardFromDeck"] = 240] = "DrawCardFromDeck";
    AnimationDuration[AnimationDuration["DrawCardStagger"] = 70] = "DrawCardStagger";
    AnimationDuration[AnimationDuration["FromRoomPlayerHandToDiscard"] = 180] = "FromRoomPlayerHandToDiscard";
    AnimationDuration[AnimationDuration["FromDeckToRoomPlayersHands"] = 180] = "FromDeckToRoomPlayersHands";
    AnimationDuration[AnimationDuration["RevealRoomPlayerCards"] = 180] = "RevealRoomPlayerCards";
    AnimationDuration[AnimationDuration["RoomPlayerAction"] = 700] = "RoomPlayerAction";
    AnimationDuration[AnimationDuration["SwapHands"] = 900] = "SwapHands";
})(AnimationDuration || (exports.AnimationDuration = AnimationDuration = {}));
const DISTRIBUTION_TARGET_MS = 2000;
const getDistributionDelay = (playerCount) => {
    return DISTRIBUTION_TARGET_MS / (playerCount * Game_1.GameConstant.startingCardsCount);
};
exports.getDistributionDelay = getDistributionDelay;
